import _ from "lodash";
// Takes a function or object and returns the object or executes the function
export const result = (funcOrObject, params, context = this) => {
    if (_.isFunction(funcOrObject)) {
        return funcOrObject.call(context, params);
    }
    return funcOrObject;
};
